import React from 'react';
import { Prompt } from 'react-router';

interface PreventNavigationProps {
  when: boolean;
  message?: string;
}

/*
 * Notifica l'utente che sta lasciando una pagina quando @when è vera.
 * Utile per evitare di lasciare form non salvati.
 * NB: se utilizzato con formik, utilizzare "dirty && !isSubmitting"
 * come condizione per evitare di essere bloccati durante il salvataggio
 * di un nuovo form prima del redirect.
 * @param props
 */
export function PreventNavigation(props: PreventNavigationProps) {
  return (
    <Prompt
      when={props.when}
      message={
        props.message ??
        'Sei sicuro di voler abbandonare la pagina? Tutte le modifiche non salvate andranno perse'
      }
    />
  );
}
